module.exports = __webpack_public_path__ + "img/1536602557.24bed32d.jpg";